"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Radio = _interopRequireDefault(require("../Radio"));
var _Label = _interopRequireDefault(require("../Label"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  radiosOrientation: 'horizontal',
  orientation: 'horizontal',
  validateOn: 'change',
  theme: {},
  skipDefaultValue: false,
  onChange: function onChange() {}
};

/**
 * Combines Radio components into a group.
 */
var RadioGroup = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RadioGroup, _React$Component);
  function RadioGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RadioGroup);
    _this = _callSuper(this, RadioGroup, [props]);
    /**
     * Returns true is element is a Radio component
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isRadioElement", function (element) {
      return element && element.type && element.type.displayName === _Radio["default"].displayName;
    });
    _this.name = _this.props.name || "radioGroup-".concat(Date.now());
    if (!_this.props.value && !_this.props.skipDefaultValue) {
      _this.setDefaultValue();
    }
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(RadioGroup, [{
    key: "onChange",
    value: function onChange(value) {
      if (this.props.disabled) {
        return;
      }
      this.setValue(value);
    }

    /**
     * Triggers onChange with passed value
     */
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.props.onChange({
        value: value
      });
    }

    /**
     * Gets first available Radio control from children and sets its value.
     * Used during the initialization step to define default value in case if it was not set explicitly.
     */
  }, {
    key: "setDefaultValue",
    value: function setDefaultValue() {
      var children = this.props.children;
      var firstRadio = _react["default"].Children.toArray(children).find(this.isRadioElement);
      if (!firstRadio) {
        return;
      }
      this.setValue(firstRadio.props.value);
    }
  }, {
    key: "renderRadioButtons",
    value: function renderRadioButtons() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        theme = _this$props.theme,
        testId = _this$props.testId,
        value = _this$props.value;
      var radios = _react["default"].Children.map(children, function (child, idx) {
        if (_this2.isRadioElement(child)) {
          return /*#__PURE__*/_react["default"].cloneElement(child, {
            key: idx,
            name: _this2.name,
            testId: child.props.testId,
            className: (0, _classnames["default"])(theme.radio, child.props.className),
            checked: value === child.props.value,
            disabled: disabled || child.props.disabled,
            onChange: _this2.onChange
          });
        }
        return child;
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-test-id": testId && "".concat(testId, "-radios"),
        className: theme.radios
      }, radios);
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props2 = this.props,
        label = _this$props2.label,
        theme = _this$props2.theme,
        testId = _this$props2.testId;
      if (!label) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_Label["default"], {
        className: theme.label,
        testId: testId && "".concat(testId, "-label")
      }, label);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        orientation = _this$props3.orientation,
        className = _this$props3.className,
        testId = _this$props3.testId,
        theme = _this$props3.theme,
        isDirty = _this$props3.isDirty,
        isFocused = _this$props3.isFocused,
        isValid = _this$props3.isValid;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(theme.RadioGroup, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, theme['radio-valid-true'], isValid), theme['radio-valid-false'], !isValid), theme['is-dirty'], isDirty), theme['is-focused'], isFocused), theme["orientation-".concat(orientation)], className),
        "data-test-id": testId,
        "data-anypoint-component": RadioGroup.displayName
      }, this.renderLabel(), this.renderRadioButtons());
    }
  }]);
  return RadioGroup;
}(_react["default"].Component);
(0, _defineProperty2["default"])(RadioGroup, "displayName", 'RadioGroup');
(0, _defineProperty2["default"])(RadioGroup, "defaultProps", defaultProps);
//# sourceMappingURL=RadioGroup.js.map